import { adapter, BREADCRUMB_FEATURE_KEY, BreadcrumbPartialState, BreadcrumbState } from './breadcrumb.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getBreadcrumbState = createFeatureSelector<
  BreadcrumbPartialState,
  BreadcrumbState
>(BREADCRUMB_FEATURE_KEY);

const { selectAll, selectEntities } = adapter.getSelectors();

const getError = createSelector( getBreadcrumbState, (state:BreadcrumbState) => state.error );

const getBreadcrumb = createSelector(
  getBreadcrumbState,
  selectAll
);

const getLastCreatedId = createSelector( getBreadcrumbState, (state:BreadcrumbState) => state.lastCreatedId );

const getIsSearching = createSelector( getBreadcrumbState, (state:BreadcrumbState) => state.isSearching );

export const BreadcrumbQuery = {
  getError,
  getBreadcrumb,
  getLastCreatedId,
  getIsSearching
};
